import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
// import Card from '../../../components/cards/ParticipantCard';
import TentsView from '../../../components/cards/TentCard';

import PrintableParticipantCard from '../../../components/cards/PrintableCards/ParticipantCards';
import Pagination from '../../../components/Pagination';
import ViewParticipantInfo from '../../../components/modals/ViewParticipantInfo';
import EditParticipantInfo from '../../../components/modals/EditParticipantInfo';
import EmptyState from '../../../components/EmptyState';
import Loader from '../../../components/Loader';
import { jsonToCSV } from '../../../utils/json-to-csv';
import { exportCSV } from '../../../utils/export-csv';
import { connect, useDispatch, useSelector } from 'react-redux';
import { dashboardActions } from '../../../redux-utils/actions/dashboard-actions';
import Swal from 'sweetalert2';
import { useAuth } from '../../../custom-hooks/useAuth';
import { encryptFormData } from '../../../utils/crypt-module/encrypt';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { LinearProgress } from '@mui/material';
import { Box } from '@mui/system';

const { updateAction } = dashboardActions;

function Tents(props) {
    const {
        participantProps,
        participantUpdateStatus,
        participantUpdateDispatchAction,
        participantUpdateSuccessData,
    } = props;

    const {
        allParticipantData,
        allParticipantStatus,
        participantArchiveStatus,
        archiveParticipant,
        archiveType,
        setArchiveType,
        handleViewParticipantOpen,
        handleViewParticipantClose,
        viewParticipantOpen,
        selectedParticipant,
        handleEditParticipantOpen,
        handleEditParticipantClose,
        editParticipantOpen,
        setSearchTerm,
        searchTerm,
        setCurrentDataParticipant,
        handlePerPageChange,
        handlePageChange,
        totalPages,
        currentPage,
        itemsPerPage,
        currentDataParticipant,
        currentDataArchive,
        filteredParticipants,
        handleArchiveUpdate,
        t,
        // participantArchiveSuccessData,
    } = participantProps;

    const dispatch = useDispatch();

    const [progress, setProgress] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
          setProgress((oldProgress) => {
            if (oldProgress === 100) {
              return 0;
            }
            const diff = Math.random() * 10;
            return Math.min(oldProgress + diff, 100);
          });
        }, 500);

        return () => {
          clearInterval(timer);
        };
      }, []);

    const participantUpdateData = useSelector(
        (state) =>
            state.dashboardState.participantUpdateSuccessData
                .participantUpdateData
    );

    // --> This space is for edit form handling
    //handle input validations
    const editFormInputObject = {
        is_fee_paid: '',
        fee_amount: '',
        payment_date: '',
        agreement_signed: '',
        media_allowed: '',
        confirmation_email_sent: '',
        tent_information: '',
        tent_supervisor: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        gender: '',
        father: '',
        mother: '',
        city: '',
        street: '',
        house_number: '',
        zip_code: '',
        landline: '',
        mobile: '',
        email: '',
        emergency_contact: '',
        fallback_number: '',
        friend_1: '',
        friend_2: '',
        siblings_in_same_tent: '',
        swimming_allowed: '',
        swimming_badge: '',
        swimming_capability: '',
        tools_allowed: '',
        vaccination_fsme: '',
        vaccination_fsme_year: '',
        vaccination_tetanus: '',
        vaccination_tetanus_year: '',
        tick_removal_allowed: '',
        allergies: '',
        vegetarian: '',
        food_intolerance: '',
        medication_allowed: '',
        medication: '',
        additional_details: '',
    };

    // USE STATES FROM EDIT PARTICIPANT INFO MODAL
    const { getLogin } = useAuth();
    const loginStorage = JSON.parse(getLogin());

    const [updatedParticipantInput, setUpdatedParticipantInput] =
        useState(editFormInputObject);
    const [errors, setErrors] = useState({});
    // const [participantUpdateData, setParticipantUpdateData] = useState({})

    const participantData = useSelector(
        (state) =>
            state.dashboardState.participantArchiveSuccessData.participantData
    );
    const location = useLocation();

    // --> THIS WAS TAKEN FROM THE EDIT PARTICIPANT INFO MODAL
    const required_fields = [
        'first_name',
        'last_name',
        'date_of_birth',
        'gender',
        'father',
        'mother',
        'city',
        'street',
        'house_number',
        'zip_code',
        'landline',
        'mobile',
        'email',
        'fallback_contact',
        'fallback_number',
        'swimming_allowed',
        'swimming_badge',
        'swimming_capability',
        'tools_allowed',
        'vaccination_fsme',
        'vaccination_tetanus',
        'tick_removal_allowed',
        'allergies',
        'vegetarian',
        'food_intolerance',
        'medication_allowed',
        'medication',
    ];

    useEffect(() => {
        setUpdatedParticipantInput(selectedParticipant);
    }, [selectedParticipant]);

    const validateInputs = () => {
        let newErrors = {};

        if (
            updatedParticipantInput.vaccination_fsme === 'yes' &&
            !updatedParticipantInput.vaccination_fsme_year
        ) {
            newErrors.vaccination_fsme_year = `${t(
                'onboarding-form-placeholders.This field is required'
            )}`;
        }

        if (
            updatedParticipantInput.vaccination_tetanus === 'yes' &&
            !updatedParticipantInput.vaccination_tetanus_year
        ) {
            newErrors.vaccination_tetanus_year = `${t(
                'onboarding-form-placeholders.This field is required'
            )}`;
        }

        required_fields.forEach((field) => {
            if (!updatedParticipantInput[field]) {
                newErrors[field] = `${t(
                    'onboarding-form-placeholders.This field is required'
                )}`;
            }
        });

        if (
            updatedParticipantInput.email &&
            !/\S+@\S+\.\S+/.test(updatedParticipantInput.email)
        ) {
            newErrors.email = `${t(
                'onboarding-form-placeholders.Email is invalid'
            )}`;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setUpdatedParticipantInput({
            ...updatedParticipantInput,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateInputs()) {
            return;
        } else {
            if (updatedParticipantInput) {
                const params = {
                    publicKey: process.env.REACT_APP_PUB_KEY_1,
                    formData: updatedParticipantInput,
                };
                //encrypt form data
                encryptFormData(params).then((encryptedData) => {
                    const form_data = {
                        id: updatedParticipantInput.id,
                        token:
                            loginStorage && loginStorage.loginData.data.token,
                        ...encryptedData,
                    };
                    participantUpdateDispatchAction(form_data, 'participant', params.formData);
                });
            }
        }
    };
    // --> END

    const printRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: 'Kitchen Cards',
    });

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: 'background.paper',
        borderRadius: '20px',
        boxShadow: 24,
        outline: '0',
        p: 4,
        zIndex: 5,
    };

    // handle export csv here
    const handleExportCsv = () => {
        const participantData = allParticipantData.filter(
            (currObj) =>
                !currObj.hasOwnProperty('tent_id') &&
                currObj.is_archived === 'no'
        );
        const csvData = jsonToCSV(participantData);

        const params = {
            csvData,
            page: 'Participants',
        };
        exportCSV(params);
    };

    // USE EFFECT FROM VIEW_PARTICIPANT_MODAL

    // --> PARTICIPANT ARCHIVE STATUS
    useEffect(() => {
        if (archiveType) {
            if (participantArchiveStatus === 'participant_archive_success') {
                handleViewParticipantClose();
                dispatch({
                    type: 'PARTICIPANT_ARCHIVE_SUCCESS_STOP',
                    payload: selectedParticipant
                        ? selectedParticipant
                        : participantData,
                    archiveType: 'yes',
                    appUrlPathname: location.pathname,
                    t
                });
            } else if (
                participantArchiveStatus === 'participant_archive_success_stop'
            ) {
                // setArchiveType(null);
            } else if (
                participantArchiveStatus === 'participant_archive_failed'
            ) {
                handleViewParticipantClose();
                // setArchiveType(null);
                Swal.fire({
                    title: `${t('swal-messages.Error')}!`,
                    // text: `There was a problem ${archiveType === 'yes' ? 'archiving' : 'unarchiving'} the participant.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                }).then((result) => {
                    if (result.isConfirmed) {
                        // dispatch({
                        //   type: "PARTICIPANT_ARCHIVE_FAILED_STOP"
                        // })
                    }
                });
            }

            const archiveInfo = {
                archiveStatus: participantArchiveStatus,
                archiveId: selectedParticipant
                    ? selectedParticipant.id
                    : participantData.id,
                archiveData: selectedParticipant,
                archiveType,
            };
            handleArchiveUpdate(archiveInfo);
        }
    }, [selectedParticipant, archiveType, participantArchiveStatus]);

    // USE EFFECT FROM EDIT PARTICIPANT INFO

    useEffect(() => {
        if (participantUpdateStatus === 'participant_update_start') {
          handleEditParticipantClose();
        }
        if (participantUpdateStatus === 'participant_update_success') {
            handleEditParticipantClose();
            Swal.fire({
                title: `${t('swal-messages.Success')}!`,
                // text: 'Participant updated successfully.',
                icon: 'success',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch({
                        type: 'PARTICIPANT_UPDATE_SUCCESS_STOP',
                        payload: updatedParticipantInput,
                    });
                }
            });
        }

        if (participantUpdateStatus === 'participant_update_failed') {
            handleEditParticipantClose();
            Swal.fire({
                title: `${t('swal-messages.Error')}!`,
                // text: 'There was a problem updating particpant',
                icon: 'error',
                confirmButtonText: 'OK',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch({
                        type: 'PARTICIPANT_UPDATE_FAILED_STOP',
                    });
                }
            });
        }
    }, [participantUpdateStatus]);

    return (
        <section className="w-full bg-[#F9F9F9] px-20 pt-10">
            <TentsView />
        </section>
    );
}


const mapStateToProps = (state) => ({
    participantUpdateStatus: state.dashboardState.participantUpdateStatus,
    participantUpdateSuccessData:
        state.dashboardState.participantUpdateSuccessData,
});

const mapDispatchToProps = (dispatch) => ({
    participantUpdateDispatchAction: (params, subpage, formData) =>
        dispatch(updateAction(params, subpage, formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Tents);
